import { MODULE } from "./generatePdf.actionTypes";

export const isGeneratingPreviewPdfStatus = (state) =>
  state.getIn([MODULE, "isGeneratingPreviewPdfStatus"]);

export default {};
